export const BASE_EXPIRED_PASSWORD_REDIRECT =
    '/auth/ResetPassword?passwordexpired=true';
export const SIGN_IN_GA_CATEGORY = 'Sign In';
export const GaActionText = {
    trackEmailFieldSelect: 'Email Field Select',
    trackPasswordFieldSelect: 'Password Field Select',
    trackRememberMeChange: 'Remember Me Change',
    trackClickForgotPassword: 'Click Forgot Password',
    trackClickResetPassword: 'Click Reset Password',
    trackClickContinue: 'Click Continue',
    trackClickFacebookLogin: 'Click Facebook Login',
    trackClickGoogleLogin: 'Click Google Login',
    trackClickAppleLogin: 'Click Apple Login',
    trackClickCreateAccount: 'Click Create Account',
    trackPasswordExpired: 'Password Expired',
    trackShowLockedError: 'Show Locked Error',
    trackShowLockedResetPassword: 'Show Locked Reset Password',
    trackClickProviderLoginLink: 'Click Provider Login Link',
};

export const TRACKING_ELEMENTS = {
    emailTextbox: 'EmailTextbox',
    forgotPasswordLink: 'ForgotPasswordLink',
    lockedErrorMessage: 'LockedErrorMessage',
    lockedResetPasswordLink: 'LockedResetPasswordLink',
    logInButton: 'LogInButton',
    passwordTextbox: 'PasswordTextbox',
    passwordExpired: 'PasswordExpired',
    rememberMeCheckbox: 'RememberMeCheckbox',
};

export const PATIENT_MODE = 'patient';
export const PROVIDER_MODE = 'provider';

export const TOO_MANY_AUTH_FAILURE_LOCKED_REDIRECT = '/locked/password';
export const LOCKED_USER_REDIRECT = '/locked';

// These url prefixes are used to match against provider pages that a provider will land on when they sign in.
// For the complete list:
// https://github.com/Zocdoc/zocdoc_web/blob/master/ZocDoc.Constants/Provider/Auth/PageFlowControlConstants.cs
export const PROVIDER_URL_PREFIX = '/provider';
export const PROFESSIONAL_URL_PREFIX = '/professionals';

export const LOGIN_TYPE = {
    google: 'google',
    facebook: 'facebook',
    apple: 'apple',
};
